import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  CalculatedParameterCreator,
  useCalculateByAttribute,
} from "../../../Classification/hooks/useCalculateByAttribute";
import { ComplexButton } from "../ComplexButton/ComplexButton";
import { ClassifyButtonProps } from "./ClassifyButton";

export const CalculateButton: FC<ClassifyButtonProps & { creator: CalculatedParameterCreator }> = ({
  name,
  children,
  mini,
  creator,
}) => {
  const { t } = useTranslation("common");
  const [options, selectOption] = useCalculateByAttribute(name, creator);

  return (
    <ComplexButton
      tooltip={mini && t("symbolEditor.classifyByAttribute")}
      icon={"classification"}
      options={options}
      selectOption={selectOption}
    >
      {children}
    </ComplexButton>
  );
};
